import { render, staticRenderFns } from "./NotFoundLayout.vue?vue&type=template&id=10b60774&lang=pug"
import script from "./NotFoundLayout.vue?vue&type=script&lang=js"
export * from "./NotFoundLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports